<template>
  <div
    :class="[
      'asc-doc-mgmt-help-about-dialog',
      isEdit
        ? 'asc-doc-mgmt-help-about-dialog--edit'
        : 'asc-doc-mgmt-help-about-dialog--upload',
    ]"
  >
    <asc-dialog
      :show-dialog="showDialog"
      :text="dialogTitle"
      :on-primary="handlePrimaryClick"
      :on-secondary="handleCancel"
      :secondary-button-text="secondaryButtonText"
      :primary-button-text="primaryButtonText"
      :primary-available="primaryAvailable"
      :on-close="handleClose"
    >
      <div class="asc-doc-mgmt-help-about-dialog--content">
        <asc-file-upload-input
          v-model="data.files"
          :on-upload-file="handleUploadAttachment"
          :on-remove-file="handleRemoveAttachment"
          :on-download-file="handleDownloadFile"
          :accepted-file-properties="acceptedFileProperties"
          :upload-error="attachmentUploadError"
          :max-file-uploads="maxFileUploads"
          :show-file-remove-notification="
            isEdit ? showFileRemoveNotification : false
          "
          :allow-file-upload="!data.files.length >= maxFileUploads"
          :allow-file-download="false"
          :allow-file-remove="true"
          viewable
        ></asc-file-upload-input>
        <asc-autocomplete-selector
          v-model="data.selectedCompanies"
          class="companies"
          label="Companies"
          component-type="multiple"
          display-clear
          fixed-position
          :items="companyOptions"
        ></asc-autocomplete-selector>
      </div>
    </asc-dialog>
  </div>
</template>

<script>
import { AscDialogMixin } from '@/components/mixins'
import AscDialog from '@/components/atoms/AscDialog'
import AscFileUploadInput from '@/components/molecules/AscFileUploadInput'
import AscAutocompleteSelector from '@/components/molecules/AscAutocompleteSelector'

export default {
  name: 'AscDocMgmtHelpAboutDialog',

  components: {
    AscDialog,
    AscFileUploadInput,
    AscAutocompleteSelector,
  },

  mixins: [AscDialogMixin],

  props: {
    userGuideId: {
      type: Number,
      default: undefined,
    },
    files: {
      type: Array,
      default: () => [],
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    allowedFileTypes: {
      type: Array,
      default: () => ['.pdf'],
    },
    acceptedFileProperties: {
      type: Object,
      default: function () {
        return {
          id: 1,
          allowedFileTypes: this.allowedFileTypes?.join(','),
          maxFileSizeInMB: 5,
        }
      },
    },
    attachmentUploadError: {
      type: Array,
      default: () => [],
    },
    onAccept: {
      type: Function,
      required: true,
    },
    selectedCompanies: {
      type: Array,
      default: () => [],
    },
    companies: {
      type: Array,
      default: () => [],
      required: true,
    },
    maxFileUploads: {
      type: Number,
      default: 1,
    },
    showFileRemoveNotification: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      data: {
        files: this.files,
        userGuide: undefined,
        selectedCompanies: this.selectedCompanies,
        removedFile: undefined,
      },
    }
  },

  computed: {
    dialogTitle() {
      return this.isEdit ? 'Edit Document' : 'Upload New Document'
    },
    primaryButtonText() {
      return this.isEdit ? 'Save Changes' : 'Upload'
    },
    secondaryButtonText() {
      return 'Cancel'
    },
    primaryAvailable() {
      // TODO: disable save button if there are no changes made in update/edit
      return Boolean(
        Number(
          this.data.files.length === this.maxFileUploads &&
            this.data.selectedCompanies.length,
        ),
      )
    },
    companyOptions() {
      return this.companies.map(item => ({
        text: item.name,
        value: item.id,
      }))
    },
  },

  watch: {
    attachmentUploadError(newValue) {
      if (newValue.length) {
        this.data.files = this.data.files.filter(item => {
          return item.displayName !== newValue[0]?.name
        })
      }
    },
    files(newValue) {
      if (newValue) {
        if (newValue.length === 0) this.data.userGuideDoc = undefined
        this.data.files = newValue
      }
    },
    selectedCompanies(newValue) {
      if (newValue) {
        this.data.selectedCompanies = newValue
      }
    },
  },

  methods: {
    handlePrimaryClick() {
      let userGuideObj = {}
      if (this.isEdit) {
        userGuideObj = {
          id: this.userGuideId,
          userGuide: this.data.userGuide,
          companyIds: this.data.selectedCompanies,
          update: true,
        }
      } else {
        userGuideObj = {
          companyIds: this.data.selectedCompanies,
          userGuide: this.data.userGuide,
          new: true,
        }
      }
      this.onAccept(userGuideObj)
      this.handleClose()
    },
    handleCancel() {
      this.handleClose()
    },
    handleClose() {
      if (this.onClose) this.onClose()
    },
    handleUploadAttachment(file) {
      this.data.userGuide = file
      this.data.files[0].loading = false
    },
    handleRemoveAttachment(file) {
      this.handleRemoveFile(file)
    },
    handleRemoveFile(file) {
      this.data.removedFile = {
        remove: true,
        file: file,
      }

      this.$emit('removeFile', this.data.removedFile)
    },
    handleDownloadFile(fileToDownload) {
      this.$emit('downloadFile', fileToDownload)
    },
  },
}
</script>

<style lang="scss">
.asc-doc-mgmt-help-about-dialog {
  .asc-dialog {
    width: 489px !important;

    .v-card__text {
      min-height: 239px !important;
      padding: 16px 16px 19px !important;

      .asc-dialog-slot {
        overflow-x: unset;
      }
    }

    .asc-doc-mgmt-help-about-dialog--content {
      .companies {
        margin: 24px 7px 0 7px;
      }
    }
  }
}
</style>
